module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_store_gold-5b15c06a1f07b28a8d7a5c75c4be8903.svg";